<template>
  <!-- 海报 -->
  <div class="poster">
    <div class="poster-top">
      <div class="poster-top-left">
        <div class="referral-item" :class="{posterNavActive:posterNavActive === index}" v-for="(item,index) in referralList" :key="index" @click="onItemClick(index,item.id)">
          <div class="referral-name">{{item.name}}</div>
          <div class="referral-child">
            {{item.child.map(item=>item.name).join(' ')}}
          </div>
        </div>
      </div>
      <div class="poster-top-center">
        <swiper class="swiper" :options="{loop: false,slidesPerView: 1,autoplay:({delay:3000})}">
          <!-- <swiper-slide class="swiper-slide"><img src="../assets/static/swiper/swiper-01.png" alt=""></swiper-slide> -->
          <swiper-slide class="swiper-slide"><img src="../assets/static/swiper/swiper-02.png" alt=""></swiper-slide>
        </swiper>
      </div>
      <div class="poster-top-right">
        <div class="test-title">
          免费试听课程
        </div>
        <div class="right-content">
          <input type="text" v-model="form.name" placeholder="您的姓名" />
          <input type="text" v-model="form.phone" placeholder="您的手机号" />
          <div class="btn" @click="onSubmit">在线预约</div>
          <div class="code">
            <img src="../assets/static/code.png" alt="">
          </div>
          <div class="mask">扫一扫咨询课程</div>
        </div>
      </div>
    </div>
    <div class="poster-list">
      <div class="poster-item" :style="'background:'+item.bgColor" v-for="(item,index) in posterList" :key="index">
        <div class="poster-icon">
          <img :src="item.icon" alt="">
        </div>
        <div class="poster-name">{{item.name}}</div>
      </div>
    </div>

    <div class="referral-list">
      <div :id="item.id" class="referral-item" v-for="(item,index) in referralList" :key="index">
        <div class="title">
          <span class="e75">{{item.alias}}课程</span>介绍
        </div>
        <div class="title-referral">
          {{item.referral}}
        </div>
        <div class="major-list">
          <div class="major-item" v-for="(citem,index) in item.child" :key="index">
            <div class="major-icon">
              <img :src="citem.icon" alt="">
            </div>
            <div class="major-center">
              <div class="major-title e75">{{citem.alias}}</div>
              <div class="major-referral"><span>课程介绍：</span>{{citem.referral}}</div>
            </div>
            <div class="major-right">
              <div class="btn btn1" @click="showService()" data-agl-cvt="1">在线报名<i class="arrow-right-01"></i></div>
              <div class="btn btn2" @click="showService()" data-agl-cvt="1">免费试听<i class="arrow-right-02"></i></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template> 

<script>
import { posterList, referralList } from "../jsons/staticjson"
// 注意下边引入的swiper和swiperSlide第一个字母s都是小写的，大写会报错
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  components: {
    swiper, swiperSlide
  },
  data() {
    return {
      posterList,
      referralList,
      posterNavActive: 0,
      form: {
        name: "",
        phone: ""
      }
    }
  },
  methods: {
    showService() {
      this.$emit("service")
    },
    onSubmit() {
      this.$emit("submit", this.form)
    },
    onItemClick(index, id) {
      this.posterNavActive = index
      location.href = '#' + id
    }
  }
}

</script> 

<style lang="scss" scoped>
.poster {
  margin-top: 18px;
  .poster-top {
    display: flex;
    height: 450px;
    .poster-top-left {
      width: 230px;
      color: #fff;
      background-color: #e7354b;

      .referral-item {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 64px;
        padding: 11px 14px;
        background-color: #e7354b;
        cursor: pointer;
        .referral-name {
          font-size: 16px;
          font-family: gb;
          font-weight: 600;
        }

        .referral-child {
          font-size: 12px;
          // color: #666;
        }
        &.posterNavActive {
          background-color: #fff;
          .referral-name {
            color: #fe556c;
          }
          .referral-child {
            color: #666;
          }
        }
      }
    }

    .poster-top-center {
      flex: 1;
      padding: 0 20px;
      .swiper {
        height: 450px;
        width: 680px;
        .swiper-slide {
          height: 450px;
        }
      }
    }

    .poster-top-right {
      width: 260px;
      height: 450px;
      border-radius: 18px;
      background-color: #fff;
      overflow: hidden;
      .test-title {
        height: 50px;
        line-height: 50px;
        background-color: #feb225;
        text-align: center;
        color: #fff;
        font-size: 24px;
        font-family: gb;
        font-weight: 600;
      }
      .right-content {
        padding: 20px 17px 0;
        input {
          height: 50px;
          line-height: 50px;
          border: none;
          outline: none;
          border-bottom: 1px solid #eee;
        }

        .btn {
          width: 220px;
          height: 48px;
          background-color: #fe556c;
          box-shadow: 0px 3px 2px 0px rgba(134, 138, 183, 0.24);
          border-radius: 24px;
          color: #fff;
          font-family: gb;
          font-weight: 600;
          font-size: 20px;
          text-align: center;
          line-height: 48px;
          margin-top: 32px;
          cursor: pointer;
        }

        .code {
          margin-top: 26px;
          display: flex;
          justify-content: center;
          img {
            height: 114px;
            width: 114px;
          }
        }

        .mask {
          margin-top: 10px;
          text-align: center;
        }
      }
    }
  }

  .poster-list {
    display: flex;
    justify-content: space-between;
    margin-top: 14px;
    .poster-item {
      display: flex;
      align-items: center;
      height: 80px;
      width: 190px;
      padding: 16px;
      .poster-icon {
        width: 40px;
        height: 40px;
      }

      .poster-name {
        flex: 1;
        font-size: 20px;
        color: #fff;
        margin-left: 16px;
      }
    }
  }

  .referral-list {
    .referral-item {
      padding-top: 54px;
      .title,
      span {
        font-family: gb;
        font-weight: 600;
        font-size: 30px;
        text-align: center;
      }

      .title-referral {
        color: #666;
        font-size: 20px;
        text-align: center;
        margin-top: 14px;
      }

      .major-list {
        margin-top: 35px;
        background-color: #fff;
        border-radius: 24px;
        padding: 44px 52px;
        .major-item {
          display: flex;
          margin-top: 50px;
          &:nth-of-type(1) {
            margin-top: 0;
          }
          .major-icon {
            width: 300px;
            height: 172px;
          }

          .major-center {
            width: 400px;
            margin-left: 60px;
            .major-title {
              border-bottom: 1px solid #dededf;
              font-family: gb;
              font-weight: 600;
              font-size: 22px;
              line-height: 66px;
              margin-top: -18px;
            }

            .major-referral {
              font-size: 16px;
              margin-top: 18px;
              line-height: 26px;
              span {
                font-size: 16px;
                line-height: 26px;
              }
            }
          }

          .major-right {
            flex: 1;
            padding-left: 124px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin-bottom: -10px;
            .btn {
              display: flex;
              align-items: center;
              justify-content: space-between;
              width: 180px;
              height: 45px;
              background-color: #fe556c;
              color: #fff;
              border-radius: 22px;
              line-height: 45px;
              padding: 0 9px 0 33px;
              box-shadow: 0px 1px 1px 0px rgba(138, 138, 138, 0.3);
              margin-top: 15px;
              cursor: pointer;
              i {
                width: 32px;
                height: 32px;
                background: url("../assets/static/btn/btn1.png") no-repeat;
                background-size: 100% 100%;
              }
            }
            .btn2 {
              background-color: #fff;
              border: 2px solid #fe556c;
              color: #fe556c;
              i {
                background-image: url("../assets/static/btn/btn2.png");
              }
            }
          }
        }
      }
    }
  }
}
</style>
